<template>
	<div id="ranking">
		<div v-if="isLoading">
			<i class="fad fa-spinner-third fa-spin fa-2x"></i>
		</div>
		<div v-else>
			<h1>
				<i class="fad fa-list-ol fa-fw"></i> 
				Ranking 
			</h1>
			<div>
				<ol>
					<li v-for="candidate in candidatesList" v-bind:key="candidate.id">
						{{candidate.score}}% &mdash; <router-link v-bind:to="'/admin/scorecard-2/card/' + candidate.user">{{candidate.nameFirst}} {{candidate.nameLast}}</router-link>
						<span class="incomplete">{{isIncomplete(candidate.completion)}}</span>
						<span class="group">{{candidate.program.slice(-1)}}</span>
					</li>
				</ol>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false
		}
	},
	computed: {
		candidatesList(){
			return this.$store.getters.candidatesSorted
		}
	},
	methods: {
		async loadScores() {
			this.isLoading = true
			await this.$store.dispatch('loadUsers')
			await this.$store.dispatch('allScoreCards2')
			this.isLoading = false
		},
		isIncomplete(completionArr){
			console.log(completionArr.indexOf('incomplete'))
			if(completionArr.indexOf('incomplete') !== -1){
				return 'incomplete'
			} else {
				return null
			}

		}
	},
	async created(){
		await this.loadScores()
	}
}
</script>
<style scoped>
ol {
	list-style-type: decimal;
	margin-left: 3ch;
}

	ol li {
		padding: 6px 0;
	}

.incomplete {
	color: #ff0000;
	display: inline-block;
	font-size: 1.2rem;
	font-weight: bold;
	margin-left: 1.5ch;
}

.group {
	background-color: #483751;
	border-radius: 50%;
	color: #fff;
	display: inline-block;
	font-size: 1.08rem;
	font-weight: bold;
	margin-left: 1.5ch;
	text-align: center;
	width: 18px;
	height: 18px;
	line-height: 18px;
}
</style>